export default __webpack_public_path__ + "static/color-picker-accessible-role-do-e12d68615d576bbcea0bc98acf734fa8.png";